import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Pencil, Trash2 } from 'lucide-react';

const TYPER = ['eiendel', 'gjeld', 'egenkapital', 'inntekt', 'kostnad'];

const tom = () => ({ nummer: '', navn: '', type: 'kostnad', mva_kode: '0', aktiv: true });

const Kontoplan = () => {
  const [kontoer, setKontoer] = useState([]);
  const [mva, setMva] = useState([]);
  const [filter, setFilter] = useState('');
  const [open, setOpen] = useState(false);
  const [redigerer, setRedigerer] = useState(null);
  const [skjema, setSkjema] = useState(tom());

  const last = async () => {
    const [k, m] = await Promise.all([api.get('/kontoer'), api.get('/mva-koder')]);
    setKontoer(k.data); setMva(m.data);
  };
  useEffect(() => { last(); }, []);

  const aapneNy = () => { setRedigerer(null); setSkjema(tom()); setOpen(true); };
  const aapneRediger = (k) => { setRedigerer(k); setSkjema({ ...k }); setOpen(true); };

  const lagre = async () => {
    if (redigerer) await api.put(`/kontoer/${redigerer.nummer}`, skjema);
    else await api.post('/kontoer', skjema);
    setOpen(false); last();
  };

  const slett = async (k) => {
    if (!window.confirm(`Slett konto ${k.nummer}?`)) return;
    try { await api.delete(`/kontoer/${k.nummer}`); last(); }
    catch (e) { alert(e.response?.data?.error || 'Feil.'); }
  };

  const synlige = kontoer.filter((k) =>
    !filter || k.nummer.includes(filter) || k.navn.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <>
      <PageHeader
        title="Kontoplan"
        subtitle="Norsk Standard Kontoplan (NS 4102)"
        actions={<button className="btn-primary" onClick={aapneNy}><Plus size={14} /> Ny konto</button>}
      />

      <Card style={{ marginBottom: 12 }}>
        <input placeholder="Søk konto…" value={filter} onChange={(e) => setFilter(e.target.value)} />
      </Card>

      <Card style={{ padding: 0 }}>
        <table>
          <thead>
            <tr><th>Nummer</th><th>Navn</th><th>Type</th><th>MVA-kode</th><th>Aktiv</th><th style={{ width: 90 }}></th></tr>
          </thead>
          <tbody>
            {synlige.map((k) => (
              <tr key={k.nummer}>
                <td><strong>{k.nummer}</strong></td>
                <td>{k.navn}</td>
                <td><span className="badge badge-neutral">{k.type}</span></td>
                <td>{k.mva_kode}</td>
                <td>{k.aktiv ? '✓' : '—'}</td>
                <td>
                  <div className="flex" style={{ gap: 4 }}>
                    <button className="btn-ghost" onClick={() => aapneRediger(k)}><Pencil size={12} /></button>
                    <button className="btn-ghost" onClick={() => slett(k)} style={{ color: 'var(--theme-danger)' }}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)}
             title={redigerer ? `Rediger konto ${redigerer.nummer}` : 'Ny konto'}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagre}>Lagre</button>
             </>}>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div><label>Nummer</label>
            <input value={skjema.nummer} disabled={!!redigerer}
                   onChange={(e) => setSkjema({ ...skjema, nummer: e.target.value })} />
          </div>
          <div><label>Type</label>
            <select value={skjema.type} onChange={(e) => setSkjema({ ...skjema, type: e.target.value })}>
              {TYPER.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div style={{ gridColumn: '1 / -1' }}><label>Navn</label>
            <input value={skjema.navn} onChange={(e) => setSkjema({ ...skjema, navn: e.target.value })} />
          </div>
          <div><label>MVA-kode</label>
            <select value={skjema.mva_kode} onChange={(e) => setSkjema({ ...skjema, mva_kode: e.target.value })}>
              {mva.map((m) => <option key={m.kode} value={m.kode}>{m.kode} – {m.navn}</option>)}
            </select>
          </div>
          <div><label>Aktiv</label>
            <select value={skjema.aktiv ? '1' : '0'} onChange={(e) => setSkjema({ ...skjema, aktiv: e.target.value === '1' })}>
              <option value="1">Ja</option><option value="0">Nei</option>
            </select>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Kontoplan;
